<template name="carrierNewApplication">
  <div class="page-carrierNewApplication">
    <Top :isDetailPage="false" :trainingId="routeId" @changeVisitListStatus="inviteListShow = true"></Top>
    <div class="main-container container">
      <NewCarrierVisitAdd/>
    </div>
    <footerMenuExternal
      :trainingId="routeId"
      :isContactSelectShow="false"
      :isDetailPage="false"
      @changeVisitListStatus="inviteListShow = true"
    ></footerMenuExternal>
    <footerExternal :isLoginPage="false"></footerExternal>
    <loading :active.sync="isLoading" :color="'#e42029'"></loading>
    <alertModal
      modalType="simple"
      :isModalShown="isNoInvitationModalShow"
      :modalTitle="noInvitationModalTitle"
      @cancel="handleLogout"
    ></alertModal>
  </div>
</template>

<script>
import { getInvitationOverview } from "@/utils/api";
import Top from "@/views/external/top.vue";
import footerExternal from "@/components/footerExternal.vue";
import footerMenuExternal from "@/components/footerMenuExternal.vue";
import NewCarrierVisitAdd from "@/components/NewCarrierVisitAdd.vue";
import alertModal from "@/components/alertModal.vue";
import Loading from "vue-loading-overlay";
import { checkNested } from "@/utils/utils";
import myAuth from "@/utils/auth";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "carrierNewApplication",
  components: {
    Top,
    NewCarrierVisitAdd,
    footerMenuExternal,
    footerExternal,
    Loading,
    alertModal
  },
  data() {
    return {
      inviteListShow: false,
      isLoading: false,
      routeId: "",
      ticketId: 0,
      isNoInvitationModalShow: false,
      noInvitationModalTitle: "",
      routId: "",
      isNeedEffective: -1
    };
  },
  watch: {
    $route() {
      this.routeId = this.$route.params.id;
      this.isNeedEffective = this.$route.params.isNeedEffective;
      this.publicFunction(this.routeId, this.isNeedEffective);
    }
  },
  created() {
    this.routeId = this.$route.params.id;
    this.isNeedEffective = this.$route.params.isNeedEffective;
    const userRole = myAuth.getLocalUserRole();
    if (userRole != 2) {
      this.publicFunction(this.routeId, this.isNeedEffective);
    }
  },
  methods: {
    publicFunction(routeId, isNeedEffective) {
      getInvitationOverview(routeId, isNeedEffective).then(res => {
        if (res.data.content.status === 1) {
          if (checkNested(res, "data", "content", "model")) {
            const { invitationId } = res.data.content.model;
            this.ticketId = invitationId;

            if (routeId != this.ticketId) {
              if (this.ticketId) {
                this.$router.push({
                  path: `/external/carrier-new-application/${
                    this.ticketId
                  }/${isNeedEffective}`
                });
              } else {
                this.isNoInvitationModalShow = true;
                this.noInvitationModalTitle = res.data.content.message;
              }
            }
          }
        } else {
          this.isNoInvitationModalShow = true;
          this.noInvitationModalTitle = res.data.content.message;
        }
      });
    },
    handleLogout() {
      this.isNoInvitationModalShow = false;
      myAuth.logoutExternal();
    }
  }
};
</script>

<style lang="scss">
.page-carrierNewApplication {
  .detail-header .row .header-right .two-link .application {
    position: relative;
    &:after {
      content: "";
      width: 100%;
      height: 3px;
      position: absolute;
      bottom: 0;
      left: 0;
      background: #e42029;
    }
    span,
    i {
      color: #e42029;
    }
  }
}
</style>